import Scene from './Scene';
import common from '../common';
import {translate, Text} from '../utils';

export default class CompetitionOverlay extends Scene {
	constructor() {
		super();
		this.overlayBg = null;

		this.container = null;
		this.bg = null;
		this.scrollBar = null;
		this.header = null;
		this.paginationContainer = null;

		this.pagesContainer = null;
		this.pageIndex = 0;
		this.pages = [];
		this.pips = [];

		this.formTextBoxes = [];

		this.dim = null;
		this.loader = null;

		this._popup = null;

		this.competitionData = {
			age             : null,
			childName       : '',
			parentFirstName : '',
			parentSurname   : '',
			parentEmail     : ''
		};
	}

	init() {
		P3.audio.muteOnVisibilityChange = false;
		this.overlayBg = new PIXI.Sprite(PIXI.Texture.WHITE);
		this.overlayBg.tint = 0x0;
		this.overlayBg.interactive = true;
		this.overlayBg.width = P3.View.width;
		this.overlayBg.height = P3.View.height;
		this.overlayBg.alpha = 0;
		this.overlayBg.anchor.set(0.5);
		this.overlayBg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(this.overlayBg);

		this._createBackground();
		this._createPages();
		const pips = this._createPaginations();

		pips.position.set(pips.width * -0.5, this.bg.height * 0.5 - 50);
		this.container.addChild(pips);

		this.container.scale.set(0);

		/**
		 * 		$"!£12"		// fail
		 * 		    A 		// fail
		 * 		A22			//pass
		 */
		this._nameRegex = /[^ &!"£$%^&*()_+\-=~\\[\]/#'@/?<>,.|¬`;:0-9]/;	// none of these special characters are allowed unless suceeded by any other char
		this.animateIn();

		// this._getCompData();
	}

	appear() {
		this.animateIn();
	}

	animateIn() {
		new P3.utils.TWEEN.Tween(this.overlayBg, this.tweens)
			.to({
				alpha: 0.8
			}, 340)
			.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
			.start();

		new P3.utils.TWEEN.Tween(this.container.scale, this.tweens)
			.to({
				x : 1, y : 1
			}, 340)
			.delay(200)
			.onComplete(() => {
				this.resize();
			})
			.easing(P3.utils.TWEEN.Easing.Back.Out)
			.start();
	}

	animateOut(payload) {
		new P3.utils.TWEEN.Tween(this.overlayBg, this.tweens)
			.to({
				alpha: 0
			}, 340)
			.delay(200)
			.easing(P3.utils.TWEEN.Easing.Quadratic.In)
			.onComplete(() => {
				window.scrollTo(0, 0);

				this.signals.previous.dispatch(payload);
			})
			.start();

		new P3.utils.TWEEN.Tween(this.container.scale, this.tweens)
			.to({
				x : 0, y : 0
			}, 340)
			.easing(P3.utils.TWEEN.Easing.Back.In)
			.start();
	}

	destroy() {
		P3.utils.destroyAllSignals(this.signals);
		P3.audio.muteOnVisibilityChange = true;

		super.destroy();
	}

	resize() {
		super.resize();
		this.overlayBg.width = P3.View.width;
	}

	validateEmail(email) {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		return re.test(String(email).toLowerCase());
	}

	update() {
		super.update();

		if (this.loader) {
			this.loader.rotation += 0.05;
		}

		if (this.pageIndex === 2) {
			let valid = false;

			valid = this._nameRegex.test(this.competitionData.childName);
			valid && (valid = this._nameRegex.test(this.competitionData.parentFirstName));
			valid && (valid = this._nameRegex.test(this.competitionData.parentSurname));
			valid && (valid = this.validateEmail(this.competitionData.parentEmail));

			this.nextBtn.visible = this.terms.selected.visible && this.privacy.selected.visible && valid;
		}
	}

	_createBackground() {
		this.container = new PIXI.Container();
		this.container.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.container.interactive = true;
		this.addChild(this.container);

		this.bg = new PIXI.mesh.NineSlicePlane(P3.assets.texture('competition_panel_9slice'), 15, 15, 15, 15);
		this.bg.width = 900;
		this.bg.height = 675;
		this.bg.pivot.set(this.bg.width * 0.5, this.bg.height * 0.5);
		this.container.addChild(this.bg);

		const states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_btn_chevron_small_out');

		this.backBtn = new P3.Button(states);
		this.backBtn.signals.click.add(() => {
			return this._onBackClick();
		}, this);
		this.backBtn.position.set(this.bg.width * -0.5 + 75, 250);
		this.backBtn.scale.set(-1);
		this.backBtn.visible = false;
		this.container.addChild(this.backBtn);

		this.nextBtn = new P3.Button(states);
		this.nextBtn.signals.click.add(() => {
			return this._onForwardClick();
		}, this);
		this.nextBtn.position.set(this.bg.width * 0.5 - 75, 250);
		this.container.addChild(this.nextBtn);

		states.icon = P3.assets.texture('ui_icon_close');
		this.closeBtn = new P3.Button(states);
		this.closeBtn.signals.click.add(() => {
			return this.animateOut('rejected');
		}, this);
		this.closeBtn.position.set(this.bg.width * 0.5 - 50, -this.bg.height * 0.5 + 50);
		this.closeBtn.scale.set(0.7);
		this.container.addChild(this.closeBtn);
	}

	_createPages() {
		this.pagesContainer = new PIXI.Container();
		this.container.addChild(this.pagesContainer);

		let page = this._createEntryPage();

		this.pagesContainer.addChild(page);
		this.pages.push(page);

		page = this._createAgeSelect();
		this.pagesContainer.addChild(page);
		this.pages.push(page);

		this.form = this._createForm();
		this.pagesContainer.addChild(this.form);
		this.pages.push(this.form);

		page = this._simplePage('', '', translate('MENU.COMPETITION_PANEL.EMAIL.BODY'));
		page.body.align = 'left';
		page.body.anchor.set(0, 0.5);
		page.body.position.set(this.bg.width * -0.5 + 90, 0);
		this.pagesContainer.addChild(page);
		this.pages.push(page);

		page = this._createFinalPage();
		this.pagesContainer.addChild(page);
		this.pages.push(page);

		for (const page1 of this.pages) {
			page1.visible = false;
		}
		this.pages[0].visible = true;
	}

	_createPaginations() {
		const container = new PIXI.Container();

		for (let i = 0; i < 5; i++) {
			const pipOff = new PIXI.Sprite(P3.assets.texture('competition_pagination_off'));

			pipOff.anchor.set(0.5);
			pipOff.position.set(i * (pipOff.width + 10), 0);
			container.addChild(pipOff);
			this.pips.push(pipOff);
		}
		this.pips[0].texture = P3.assets.texture('competition_pagination_on');

		return container;
	}

	_onBackClick() {
		this.pages[this.pageIndex].visible = false;
		this.pageIndex = Math.max(0, this.pageIndex - 1);
		this.pages[this.pageIndex].visible = true;

		this.backBtn.visible = this.pageIndex === 1 || this.pageIndex === 2;
		this.closeBtn.visible = this.nextBtn.visible = this.pageIndex !== 4;

		this.pips.forEach((entity, index) => {
			const texture = index === this.pageIndex ? P3.assets.texture('competition_pagination_on') : P3.assets.texture('competition_pagination_off');

			entity.texture = texture;
		});
	}

	_onForwardClick() {
		this.pages[this.pageIndex].visible = false;
		this.pageIndex = Math.min(this.pages.length - 1, this.pageIndex + 1);
		this.pages[this.pageIndex].visible = true;

		this.backBtn.visible = this.pageIndex === 1 || this.pageIndex === 2;
		this.closeBtn.visible = this.nextBtn.visible = this.pageIndex !== 4;

		if (this.pageIndex === 3) {
			for (let i = 0; i < 3; i++) {
				this.pages[i].destroy({children: true});
			}

			for (const tb of this.formTextBoxes) {
				tb.destroy();
			}
		}

		const names = [
			'entry page',
			'age select page',
			'form page',
			'email confirmation page',
			'final page'
		];

		common.t.track('modal view event', {
			//pagename       : `${common.config.language}/ben10omnicode/${this.pageIndex + 1}`,
			section        : 'shows',
			subsection     : 'ben10',
			sectionlevel3  : 'games',
			contenttype    : 'sig0nup page',
			contenttitle   : `ben10 omnicode competition signup ${names[this.pageIndex]}`,
			modalviewevent : 1
		});

		this.pips.forEach((entity, index) => {
			const texture = index === this.pageIndex ? P3.assets.texture('competition_pagination_on') : P3.assets.texture('competition_pagination_off');
			entity.texture = texture;
		});
	}

	_simplePage(hT = '', sT = '', bT = '') {
		const container = new PIXI.Container();

		const header = Text(hT, {font: '32px PT Sans', align: 'left'});
		header.anchor.set(0.5, 0);
		header.position.set(0, this.bg.height * -0.5 + header.height);
		header.maxWidth = this.bg.width - 100;
		container.addChild(header);

		const subheader = Text(sT, {font: '24px PT Sans', align: 'left'});
		subheader.anchor.set(0);
		subheader.position.set(0, header.y + header.height + subheader.height);
		subheader.maxWidth = this.bg.width - 100;
		container.addChild(subheader);

		const body = Text(bT, {font: '24px PT Sans', align: 'left'});
		body.anchor.set(0);
		body.maxWidth = this.bg.width - 100;
		body.position.set(0, 0);
		container.addChild(body);

		container.header = header;
		container.subheader = subheader;
		container.body = body;

		return container;
	}

	_createEntryPage() {
		const container = this._simplePage('', translate('MENU.COMPETITION_PANEL.ENTRY.SUBHEADER'), translate('MENU.COMPETITION_PANEL.ENTRY.BODY'));

		const score = translate('MENU.SELECT_LEVEL.COMPETITION.YOURSCORE');

		const scoreDisplay = new PIXI.Sprite(P3.assets.texture('competition_score'));
		scoreDisplay.anchor.set(0.5);
		scoreDisplay.scale.set(0.8);
		scoreDisplay.position.set(0, -230);
		container.addChild(scoreDisplay);

		const scoreContainer = new PIXI.Container();
		scoreDisplay.addChild(scoreContainer);

		const scoreHeader = Text(score, {font: '32px PT Sans', align: 'left'});
		scoreHeader.tint = 0xFFFFFF;
		scoreHeader.anchor.set(0, 0.5);
		scoreContainer.addChild(scoreHeader);

		let scoreValue = Text(`${common.totalScore}`, {font: '42px Ahkio Regular', align: 'center'});
		scoreValue.tint = 0xABF546;
		scoreValue.anchor.set(0, 0.5);
		scoreValue.position.set(scoreHeader.x + scoreHeader.width + 10, scoreHeader.y - 3);
		scoreContainer.addChild(scoreValue);

		scoreContainer.position.set(scoreContainer.width * -0.5, 0);

		const img = new PIXI.Sprite(P3.assets.texture('competition_picture'));
		img.anchor.set(0.5, 0);
		container.addChild(img);

		container.addChild(container.subheader);

		container.subheader.position.set(this.bg.width * -0.5 + 90, -170);
		img.position.set(0, container.subheader.y + container.subheader.height + 10);
		container.body.position.set(this.bg.width * -0.5 + 90, img.position.y + img.height + 10);

		return container;
	}

	_createAgeSelect() {
		const c = this._simplePage(translate('MENU.COMPETITION_PANEL.AGE.HEADER'));

		c.header.position.set(0, -200);
		const t = [
			{name: 'sevenBtn', pos: new PIXI.Point(-125, 0), text: translate('MENU.COMPETITION_PANEL.AGE.SEVEN'), value: 7},
			{name: 'eightBtn', pos: new PIXI.Point(125, 0), text: translate('MENU.COMPETITION_PANEL.AGE.EIGHT'), value: 8}
		];

		for (let i = 0; i < 2; i++) {
			this[t[i].name] = new PIXI.Container();
			this[t[i].name].position.copy(t[i].pos);
			this[t[i].name].vaue = t[i].value;
			c.addChild(this[t[i].name]);

			const bg = new PIXI.Sprite(P3.assets.texture('competition_btn_age_off'));

			bg.anchor.set(0.5);
			this[t[i].name].addChild(bg);
			this[t[i].name].bg = bg;

			const text = Text(t[i].text, {font: '24px PT Sans', align: 'left'});
			text.maxWidth = bg.width - 20;
			text.anchor.set(0.5);
			this[t[i].name].addChild(text);

			this[t[i].name].interactive = this[t[i].name].buttonMode = true;
			this[t[i].name].on('pointertap', () => {
				this._onAgeSelect(t[i].value);
			});
		}
		this._onAgeSelect(7);

		return c;
	}

	_onAgeSelect(value) {
		this.competitionData.age = value;
		this.sevenBtn.bg.texture = this.competitionData.age === 7 ? P3.assets.texture('competition_btn_age_on') : P3.assets.texture('competition_btn_age_off');
		this.eightBtn.bg.texture = this.competitionData.age === 7 ? P3.assets.texture('competition_btn_age_off') : P3.assets.texture('competition_btn_age_on');
	}

	_createForm() {
		const page = this._simplePage();

		let body = Text(translate('MENU.COMPETITION_PANEL.FORM.BODY_TOP'), {font: '26px PT Sans', align: 'left'});

		body.anchor.set(0.5);
		body.maxWidth = 650;
		body.position.set(0, -250);
		page.addChild(body);

		const tb = [
			{name: 'childName', tP: new PIXI.Point(135, -150), text: {pos: new PIXI.Point(-375, -150), text: translate('MENU.COMPETITION_PANEL.FORM.QUESTIONS.CHILD')}},
			{name: 'parentFirstName', tP: new PIXI.Point(135, -100), text: {pos: new PIXI.Point(-375, -100), text: translate('MENU.COMPETITION_PANEL.FORM.QUESTIONS.PARENT_FIRST')}},
			{name: 'parentSurname', tP: new PIXI.Point(135, -50), text: {pos: new PIXI.Point(-375, -50), text: translate('MENU.COMPETITION_PANEL.FORM.QUESTIONS.PARENT_SUR')}},
			{name: 'parentEmail', tP: new PIXI.Point(135, 0), text: {pos: new PIXI.Point(-375, 0), text: translate('MENU.COMPETITION_PANEL.FORM.QUESTIONS.PARENT_EMAIL')}}
		];

		for (const tbElement of tb) {
			const main = new PIXI.Container();

			page.addChild(main);

			const body = Text(tbElement.text.text, {font: '18px PT Sans', align: 'left'});

			body.anchor.set(0, 0.5);
			body.maxWidth = 280;
			body.position.copy(tbElement.text.pos);
			page.addChild(body);

			const tbContainer = new PIXI.Container();
			tbContainer.position.copy(tbElement.tP);
			main.addChild(tbContainer);

			// tbContainer.bg = new PIXI.mesh.NineSlicePlane(P3.assets.texture('competition_panel_9slice'), 10, 10, 10, 10);
			tbContainer.bg = new PIXI.TextInput({
				input: {
					fontSize : '14pt',
					padding  : '5px',
					width    : '400px',
					height   : '20px',
					overflow : 'auto !important',
					color    : '#f2f2f2'
				},
				box: {
					default  : {fill: 0x0f0f0f, rounded: 0, stroke: {color: 0xB1D41C, width: 2}},
					focused  : {fill: 0x0f0f0f, rounded: 0, stroke: {color: 0xB1D41C, width: 2}},
					disabled : {fill: 0x0f0f0f, rounded: 0}
				}
			});

			tbContainer.bg.on('pointerupoutside', () => {
				tbContainer.bg.blur();
			});
			tbContainer.bg.on('input', () => {
				this.competitionData[tbElement.name] = tbContainer.bg.text;
			});
			tbContainer.bg.on('focus', () => {
				this.competitionData[tbElement.name] = tbContainer.bg.text;
				P3.input.refocus = false;
			});
			tbContainer.bg.on('blur', () => {
				this.competitionData[tbElement.name] = tbContainer.bg.text;
				P3.input.refocus = true;
			});
			// tbContainer.bg.width = 400;
			// tbContainer.bg.height = 40;
			tbContainer.bg.position.set(tbContainer.bg.width * -0.5, tbContainer.bg.height * -0.5);
			tbContainer.addChild(tbContainer.bg);

			this.formTextBoxes.push(tbContainer.bg);
		}

		const disclaimer = Text(translate('MENU.COMPETITION_PANEL.FORM.AGREEMENTS.DISCLAIMER'), {font: '18px PT Sans', align: 'left'});
		disclaimer.maxWidth = 540;
		disclaimer.position.set(this.bg.width * -0.5 + 180, 50);
		page.addChild(disclaimer);

		const boxes = Text(translate('MENU.COMPETITION_PANEL.FORM.AGREEMENTS.BOXES'), {font: '18px PT Sans', align: 'left'});
		boxes.anchor.set(0);
		boxes.maxWidth = 540;
		boxes.position.set(this.bg.width * -0.5 + 180, disclaimer.y + disclaimer.textHeight + 5);
		page.addChild(boxes);

		let container = new PIXI.Container();
		container.scale.set(0.5);
		page.addChild(container);

		this.privacy = new PIXI.Sprite(P3.assets.texture('competition_panel_9slice'));
		this.privacy.anchor.set(0.5);
		container.addChild(this.privacy);

		this.privacy.selected = new PIXI.Sprite(P3.assets.texture('competition_tick'));
		this.privacy.selected.anchor.set(0.5);
		this.privacy.selected.scale.set(2);
		this.privacy.selected.visible = false;
		this.privacy.addChild(this.privacy.selected);

		container.interactive = container.buttonMode = true;
		container.on('pointertap', () => {
			for (const tb of this.formTextBoxes) {
				tb.blur();
			}
			this.privacy.selected.visible = !this.privacy.selected.visible;
		});

		let string = translate('MENU.COMPETITION_PANEL.FORM.AGREEMENTS.PRIVACY');
		body = Text(string.replace(/\$/g, ''), {font: '16px PT Sans', align: 'left'});
		body.anchor.set(0, 0.5);
		body.maxWidth = 600;
		body.interactive = body.buttonMode = true;
		body.on('pointertap', () => {
			window.open(common.config.competition_data.urls.privacy[common.config.language]);
		});
		page.addChild(body);
		this._underlineText(body, string);

		let privacyHitArea = new PIXI.Rectangle(-10, this.privacy.texture.height * -0.25, 530, this.privacy.texture.height * 0.5);
		body.hitArea = privacyHitArea;

		container.position.set(-250, boxes.y + container.height * 0.5 + boxes.height * 0.5 + 20);
		body.position.set(container.x + 40, container.y);

		container = new PIXI.Container();
		container.position.set(-250, 185);
		container.scale.set(0.5);
		page.addChild(container);

		this.terms = new PIXI.Sprite(P3.assets.texture('competition_panel_9slice'));
		this.terms.anchor.set(0.5);
		container.addChild(this.terms);

		this.terms.selected = new PIXI.Sprite(P3.assets.texture('competition_tick'));
		this.terms.selected.anchor.set(0.5);
		this.terms.selected.position.set(0, 0);
		this.terms.selected.scale.set(2);
		this.terms.selected.visible = false;
		this.terms.addChild(this.terms.selected);

		container.interactive = container.buttonMode = true;
		container.on('pointertap', () => {
			for (const tb of this.formTextBoxes) {
				tb.blur();
			}
			this.terms.selected.visible = !this.terms.selected.visible;
		});

		string = translate('MENU.COMPETITION_PANEL.FORM.AGREEMENTS.TERMS');
		body = Text(string.replace(/\$/g, ''), {font: '16px PT Sans', align: 'left'});
		body.anchor.set(0, 0.5);
		body.maxWidth = 600;
		body.interactive = body.buttonMode = true;
		body.on('pointertap', () => {
			this._getTerms();
		});
		this._underlineText(body, string);

		let termsHitArea = new PIXI.Rectangle(-10, this.terms.texture.height * -0.25, 530, this.terms.texture.height * 0.5);
		body.hitArea = termsHitArea;

		container.position.set(-250, this.privacy.parent.y + container.height + 5);
		body.position.set(container.x + 40, container.y);
		page.addChild(body);

		return page;
	}

	_underlineText(bitmapText, string) {
		bitmapText.validate();	// so if there's newlines etc, they'll be applied
		string = string.trim();

		const firstFlag = string.indexOf('$');
		const lastFlag = string.lastIndexOf('$') - 1;

		if (firstFlag === -1 || lastFlag === -1 || firstFlag === lastFlag) {	// if we havent found two flags, return
			console.warn('No flags found');
			return;
		}

		let childFirstFlag = bitmapText.children[firstFlag];
		let childLastFlag = bitmapText.children[lastFlag - 1];

		if (bitmapText.text.length > bitmapText.children.length) {		// why would this ever be true? i dont know, but it happens...
			childFirstFlag = bitmapText.children[firstFlag - 1];
			childLastFlag = bitmapText.children[lastFlag - 2];
		}

		const width = (childLastFlag.x - childFirstFlag.x) + childLastFlag.width;
		let highest = -Infinity;
		for (let i = firstFlag; i < lastFlag; i++) {		// gets the highest Y level for us so we can align the underline to that
			if (!bitmapText.children[i]) {
				continue;
			}

			if (bitmapText.children[i].y > highest) {
				highest = bitmapText.children[i].y;
			}
		}

		let underline = new PIXI.Graphics();
		underline.beginFill(0xFFFFFF);
		underline.drawRect(0, 0, width, 1);
		underline.endFill();
		underline.position.set(childFirstFlag.x, Math.abs(highest));
		bitmapText.addChild(underline);
	}

	_createFinalPage() {
		const c = this._simplePage('', '', '');

		const header = Text(translate('MENU.COMPETITION_PANEL.FINISHED.HEADER'), {font: '38px PT Sans', align: 'left'});
		header.tint = 0xFFFFFF;
		header.anchor.set(0.5);
		header.position.set(0, -275);
		c.addChild(header);

		const score = translate('MENU.SELECT_LEVEL.COMPETITION.YOURSCORE').replace('$SCORE$', common.totalScore || 0);

		const scoreDisplay = new PIXI.Sprite(P3.assets.texture('competition_score'));
		scoreDisplay.anchor.set(0.5);
		scoreDisplay.scale.set(0.8);
		scoreDisplay.position.set(0, -170);
		c.addChild(scoreDisplay);

		const scoreContainer = new PIXI.Container();
		scoreDisplay.addChild(scoreContainer);

		const scoreHeader = Text(score, {font: '32px PT Sans', align: 'left'});
		scoreHeader.tint = 0xFFFFFF;
		scoreHeader.anchor.set(0, 0.5);
		scoreContainer.addChild(scoreHeader);

		let scoreValue = Text(`${common.totalScore}`, {font: '42px Ahkio Regular', align: 'center'});
		scoreValue.tint = 0xABF546;
		scoreValue.anchor.set(0, 0.5);
		scoreValue.position.set(scoreHeader.x + scoreHeader.width + 10, scoreHeader.y - 3);
		scoreContainer.addChild(scoreValue);

		scoreContainer.position.set(scoreContainer.width * -0.5, 0);

		const body = Text(translate('MENU.COMPETITION_PANEL.FINISHED.BODY'), {font: '18px PT Sans', align: 'left'});
		body.tint = 0xFFFFFF;
		body.anchor.set(0.5, 0);
		body.maxWidth = 700;
		body.position.set(0, scoreDisplay.y + scoreDisplay.height * 0.5 + 20);
		c.addChild(body);

		const footer = Text(translate('MENU.COMPETITION_PANEL.FINISHED.FOOTER'), {font: '28px PT Sans', align: 'left'});
		footer.tint = 0xFFFFFF;
		footer.anchor.set(0.5);
		footer.maxWidth = 700;
		footer.position.set(0, body.y + body.height + 50);
		c.addChild(footer);

		const states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_play_small');

		const enterBtn = new P3.Button(states);
		enterBtn.signals.click.once(() => {
			enterBtn.visible = false;

			this.showLoader();

			this._getCompData()
				.then(() => {
					this.dim.destroy();
					this.dim = null;

					this.loader.destroy();
					this.loader = null;

					this.animateOut('accepted');
				});
		}, this);

		enterBtn.position.set(0, this.bg.height * 0.5 - 125);

		c.addChild(enterBtn);

		return c;
	}

	showLoader() {
		// dim
		this.dim = new PIXI.Sprite(PIXI.Texture.WHITE);

		this.dim.tint = 0x0;
		this.dim.anchor.set(0.5);
		this.dim.alpha = 0.5;
		this.dim.x = common.STAGE_WIDTH >> 1;
		this.dim.y = common.STAGE_HEIGHT >> 1;

		this.dim.width = P3.View.width + 2;
		this.dim.height = P3.View.height + 2;

		this.addChild(this.dim);

		// loader
		this.loader = new PIXI.Sprite(P3.assets.texture('competition_loader'));

		this.loader.anchor.set(0.5);
		this.loader.x = this.dim.x;
		this.loader.y = this.dim.y;

		this.addChild(this.loader);
	}

	_getCompData() {
		return new Promise((resolve, reject) => {
			const competitionID = this.competitionData.age === 7 ? common.config.competition_data.competition_id['7below'][common.config.language] : common.config.competition_data.competition_id['8above'][common.config.language];
			const authToken = this.competitionData.age === 7 ? common.config.competition_data.auth_token['7below'][common.config.language] : common.config.competition_data.auth_token['8above'][common.config.language];

			$.ajax({
				url     : `https://api.competitions.tectonicinteractive.com/polling/competition/${competitionID}`,
				headers : {
					// 'X-Preview-Token': common.config.competition_data.preview_token[common.config.language],
					'X-Auth-Token': authToken
				},
				method      : 'GET',
				crossDomain : true,
				contentType : 'application/json',
				success     : (response) => {
					console.log('[TECTONIC] Message from Tectonic: ', response);
					this.answerID = response.answers[0].id;
					resolve();
				},
				error: (err) => {
					console.error(err);
					reject(err);
				}});
		})
			.then(() => {
				return this._postToDB();
			})
			.then((result) => {
				return this._postToComp(result);
			})
			.catch((err) => {
				return console.error(err);
			});
	}

	_postToDB() {
		return new Promise((resolve, reject) => {
			let currentscore = common.totalScore;

			if (isNaN(currentscore)) {
				currentscore = 0;
			}

			$.ajax({
				url  : 'https://jr9huo6y8e.execute-api.eu-west-1.amazonaws.com/testing/ben10-entry',
				type : 'POST',
				data : JSON.stringify({
					message: {
						payload: {
							score  : currentscore,
							region : common.config.language,
							time   : Date.now(),
							age    : this.competitionData.age || 7
						},
						type: 'set_score'
					}
				}),
				dataType    : 'json',
				crossDomain : true,
				contentType : 'application/json',
				success     : (result) => {
					resolve(result);
				},
				error: (err) => {
					console.error('set_score error: ', err);
					reject(err);
				}
			});
		});
	}

	_postToComp(dbResult) {
		return new Promise((resolve, reject) => {
			const competitionID = this.competitionData.age === 7 ? common.config.competition_data.competition_id['7below'][common.config.language] : common.config.competition_data.competition_id['8above'][common.config.language];
			const authToken = this.competitionData.age === 7 ? common.config.competition_data.auth_token['7below'][common.config.language] : common.config.competition_data.auth_token['8above'][common.config.language];

			common.competitionData = {payload: dbResult};

			const data = {
				answer_id : this.answerID,
				email     : this.competitionData.parentEmail || 'test@test.com',
				details   : {
					tandc         : true,
					childName     : this.competitionData.childName || 'test',
					parentName    : this.competitionData.parentFirstName || 'test',
					parentSurname : this.competitionData.parentSurname || 'test',
					policy        : true
				},
				tiebreaker_answer: common.competitionData.payload.id
			};

			$.ajax({
				url     : `https://api.competitions.tectonicinteractive.com/polling/competition/${competitionID}`,
				headers : {
					// 'X-Preview-Token': common.config.competition_data.preview_token[common.config.language],
					'X-Auth-Token' : authToken,
					'Content-Type' : 'application/json'
				},
				method      : 'POST',
				data        : JSON.stringify(data),
				dataType    : 'json',
				crossDomain : true,
				contentType : 'application/json',
				success     : (result) => {
					console.log('[TECTONIC] Message from Tectonic: ', result);
					localStorage.setItem('competition_entry', JSON.stringify({payload: dbResult}));
					common.entryDetails = this.competitionData;
					resolve();
				},
				error: (err) => {
					console.error(err);
					common.competitionData = {};
					reject(err);
				}});
		});
	}

	_getTerms() {
		if (this._popup) {	// only allow one popup present
			return;
		}

		const competitionID = this.competitionData.age === 7 ? common.config.competition_data.competition_id['7below'][common.config.language] : common.config.competition_data.competition_id['8above'][common.config.language];
		const authToken = this.competitionData.age === 7 ? common.config.competition_data.auth_token['7below'][common.config.language] : common.config.competition_data.auth_token['8above'][common.config.language];

		$.ajax({
			url     : `https://api.competitions.tectonicinteractive.com/polling/competition/${competitionID}/regulations`,
			headers : {
				'X-Auth-Token' : authToken,
				'Content-Type' : 'application/json'
			},
			method      : 'GET',
			crossDomain : true,
			contentType : 'application/json',
			success     : (result) => {
				console.log('[TECTONIC] Message from Tectonic: ', result);
				this._createTOCDiv(result.regulations);
			},
			error: (err) => {
				console.error(err);
			}
		});
	}

	_createTOCDiv(html) {
		if (this._popup) {
			this._popup.remove();
			this._popup = null;
		}

		this._popup = $(`
		<div id="toc">
			<div id="header">
				<i id="closeIcon" class="fas fa-times-circle"></i>
			</div>
			<div id="content">
				${html}
			</div>
		</div>
		`).appendTo('#game');

		$('#closeIcon').click(() => {
			this._popup.remove();
			this._popup = null;
		});
	}

	getCompetitionEntry(id, resolve, reject) {
		$.ajax({
			url  : 'https://jr9huo6y8e.execute-api.eu-west-1.amazonaws.com/testing/ben10-entry',
			type : 'POST',
			data : JSON.stringify({
				message: {
					payload: {
						id: id
					},
					type: 'get_entry'
				}
			}),
			dataType    : 'json',
			crossDomain : true,
			contentType : 'application/json',
			success     : (result) => {
				resolve(Object.assign({}, {type: 'success', payload: result}));
			},
			error: (err) => {
				reject({type: 'error', msg: 'An Error has occured when getting user entry', error: err});
			}
		});
	}
}
